import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../utils/Api";

// Async Thunk for User Login
export const userLogin = createAsyncThunk('admin/user', async (data, ThunkApi) => {
    try {
        const res = await Api.post('/login', data);
        if (res.data.success) {
            const userData = {
                token: res.data.token,
                email: res.data.email,
                userData: res.data.userData,
                loggedinUserId: res.data.id,
                role: res.data.userData.role
            };
            localStorage.setItem('_pildat', JSON.stringify(userData));
            return userData;
        } else {
            return ThunkApi.rejectWithValue(res.data.message);
        }
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            return ThunkApi.rejectWithValue(error.response.data.message);
        } else {
            return ThunkApi.rejectWithValue(error.message);
        }
    }
});

// Slice definition
export const userSlice = createSlice({
    name: 'user',
    initialState: {
        user: null,
        isLoading: false,
        isSuccess: false,
        message: ''
    },
    reducers: {
        resetData: (state) => {
            state.message = '';
        },
        // New reducer to update user data
        updateUserState: (state, action) => {
            // Update user state with the new user data from action.payload
            state.user = {
                ...state.user,
                ...action.payload, // Merge existing user data with updated data
            };
        }
    },
    extraReducers: (builder) => {
        builder.addCase(userLogin.pending, (state) => {
            state.isLoading = true;
            state.isSuccess = false;
        });
        builder.addCase(userLogin.fulfilled, (state, action) => {
            state.user = action.payload;
            state.isLoading = false;
            state.isSuccess = true;
        });
        builder.addCase(userLogin.rejected, (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.message = action.payload;
        });
    }
});

export const { resetData, updateUserState } = userSlice.actions;
export default userSlice.reducer;